import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { qrtListUsers } from "../../apis/qrtAdmin";
import { UserPicker } from "./qrtUi";

export function useScopedUser() {
  const [params, setParams] = useSearchParams();
  const [users, setUsers] = useState([]);
  const userId = params.get("user") || "";

  useEffect(() => {
    qrtListUsers({ limit: 100, offset: 0 })
      .then((res) => setUsers(res.data?.data?.rows || []))
      .catch(() => {});
  }, []);

  const setUserId = (id) => {
    const next = new URLSearchParams(params);
    if (id) next.set("user", id);
    else next.delete("user");
    setParams(next, { replace: true });
  };

  const selected = users.find((u) => String(u.id) === String(userId));
  return { userId, setUserId, users, selected };
}

export const ScopedPage = ({ title, noun, children }) => {
  const navigate = useNavigate();
  const { userId, setUserId, users, selected } = useScopedUser();

  return (
    <div>
      <div className="qrt-page-head">
        <div>
          <h2>{title}</h2>
          <p>
            {selected
              ? `${selected.name} · ${selected.email}`
              : `Pick a user to see their ${noun}`}
          </p>
        </div>
        <div className="grow" />
        <UserPicker users={users} value={userId} onChange={setUserId} placeholder={`Select a user to view ${noun}…`} />
        {userId && (
          <button type="button" className="ping-btn ping-btn-ghost ping-btn-sm"
            onClick={() => navigate(`/qrt/users/${userId}`)}>
            Open account
          </button>
        )}
      </div>
      {!userId ? (
        <div className="qrt-card">
          <div className="qrt-empty-pick">
            Select a user above. {title} are always shown one account at a time.
          </div>
        </div>
      ) : children(userId, selected)}
    </div>
  );
};
